Vue.component('admin-announcement', {
    template: templates.adminAnnouncement,
    data() {
      return {
        model: {
            expandedRow: '',
            edit: false,
            announcement: {
                id: null,
                name: null,
                description: null,
                active: false,
                from: null,
                to: null,
                cooldown: null,
                isAboveImage: false,
                images: {},
                titleSize: 2.5,
                descSize: 1.2,
                verticalPos: 'bottom',
                horizontalPos: 'left',
            },
            timer: null,
            announcements: [],
            timers: {}, 
        },
        cancelTokenSource: null,
        currentSlideIndex: 0,
        previewMode: 'multi',
     
       
        
        
        titleText: 'Important Announcement',
        descText: 'This is a sample announcement description. It provides key details about the event or update, ensuring users can read it clearly over the sliding images.',
      }
    },
    computed: {
      slides() {
        const images = this.model.announcement.images;
        
        // Check if images exists and is an object
        if (images && Object.keys(images).length > 0) {
            return Object.values(images).map(img => 
              `${this.getAnnouncementUrl()}${img}`
            );
        } else {
          // Return default slides with type property
          return [
            {
              type: 'image',
              src: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1200'
            },
            {
              type: 'image',
              src: 'https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=1200'
            },
            {
              type: 'image',
              src: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=1200'
            }
          ];
        }
      },
      overlayStyle() {
        const baseStyle = {
          textAlign: this.model.announcement.horizontalPos,
          transition: 'all 0.3s ease'
        };

        if (this.model.announcement.verticalPos === 'top') {
          return {
            ...baseStyle,
            top: '0',
            bottom: 'auto',
            padding: '30px 30px 20px',
            background: 'linear-gradient(rgba(0, 0, 0, 0.7), transparent)',
            transform: 'none'
          };
        } else if (this.model.announcement.verticalPos === 'center') {
          return {
            ...baseStyle,
            top: '50%',
            bottom: 'auto',
            padding: '40px 30px',
            background: 'rgba(0, 0, 0, 0.7)',
            transform: 'translateY(-50%)'
          };
        } else {
          return {
            ...baseStyle,
            top: 'auto',
            bottom: '0',
            padding: '40px 30px 30px',
            background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.7))',
            transform: 'none'
          };
        }
      },
      titleStyle() {
        return {
          fontSize: `${this.model.announcement.titleSize}rem`,
          textAlign: this.model.announcement.horizontalPos
        };
      },
      descriptionStyle() {
        const style = {
          fontSize: `${this.model.announcement.descSize}rem`
        };

        if (this.model.announcement.horizontalPos === 'center') {
          style.maxWidth = '100%';
          style.margin = '0 auto';
        } else if (this.horizontalPos === 'left') {
          style.maxWidth = '80%';
          style.margin = '0';
        } else {
          style.marginLeft = 'auto';
        }

        return style;
      }
    },
    mounted() {
      const c = this;
      c.get();
      c.connect();
      c.startSlider();
      c.$root.$on('remove-existing-image', data => {

        c.removeCurrentFile(data);
      })
      // c.startTimers()
     
    },
    beforeDestroy() {
      const c= this;
      // c.stopSendingData();
      if (c.ws) {
        c.ws.close();
      }

      if (c.cancelTokenSource) {
        c.cancelTokenSource.cancel('Request canceled due to component destruction.');
      }
    },
    methods: {
        connect() {
            const c = this;
            c.ws = new WebSocket(utils.getWsUrl());
        
            c.ws.onmessage = (event) => {
        
                const messageData = event.data;
        
                try {
        
                const parsedData = JSON.parse(messageData);
            
        
                } catch (error) {
                console.error('Error parsing message data:', error);
                }
            
            };
        
            c.ws.onopen = () => {
                console.log('WebSocket connection established');
            };
        
            c.ws.onclose = () => {
                console.log('WebSocket connection closed');
            };
        },
        toggleDetails(index, data) {
 
          const c = this;

          c.model.expandedRow = c.model.expandedRow === index ? null : index;

          if(c.model.expandedRow != null){
           
            c.model.announcement = {
                id: data.id,
                name: data.name,
                description: data.description,
                active: data.active,
                from: data.startDate,
                to: data.endDate,
                titleSize: data.titleSize,
                descSize: data.descSize,
                verticalPos: data.verticalPos,
                horizontalPos: data.horizontalPos,
                images: data.images
            }
          }
          else{
            c.reset();
          }
          
            console.log(c.model)

        },
        startSlider() {
          const c = this;
          c.slideInterval = setInterval(() => {
            c.nextSlide();
          }, 5000);
        },
        showSlide(index) {
          const c = this;
          if (index >= c.slides.length) {
            c.currentSlideIndex = 0;
          } else if (index < 0) {
            c.currentSlideIndex = c.slides.length - 1;
          } else {
            c.currentSlideIndex = index;
          }
        },
        nextSlide() {
          const c = this;
          c.currentSlideIndex = (c.currentSlideIndex + 1) % c.slides.length;
        },
        currentSlide(index) {
          const c = this;
          c.currentSlideIndex = index;
        },
        resetToDefaults() {
          const c = this;
          c.titleSize = 2.5;
          c.descSize = 1.2;
          c.verticalPos = 'bottom';
          c.horizontalPos = 'left';
          c.titleText = 'Important Announcement';
          c.descText = 'This is a sample announcement description. It provides key details about the event or update, ensuring users can read it clearly over the sliding images.';
        },
        startTimers() {
          const c = this;

          setInterval(() => {
            let announcement = c.model.announcement
            if (announcement.cooldown > 0) {
              // let seconds = Math.round(inventory.cooldown * 60);
              announcement.cooldown -= 1; 

              c.formatTime(announcement.cooldown)
            }
            else{
              c.isOpen = false;
            }
            
    
          }, 1000);
          
        },
        formatTime(time) {
          const c = this;
          // Days, hours, minutes, and seconds
          var days = ~~(time / 86400); // Calculate days
          var hrs = ~~((time % 86400) / 3600); // Calculate hours
          var mins = ~~((time % 3600) / 60); // Calculate minutes
          var secs = ~~time % 60; // Calculate seconds
      
          var ret = "";
          if (days > 0) {
              ret += days + " days "; 
          }
          if (hrs > 0) {
              ret += hrs + "h:" + (mins < 10 ? "0" : "");
          }
          ret += mins + "m:" + (secs < 10 ? "0" : "");
          ret += secs;
      
          c.model.timer = ret;
        },
        get() {
            const c = this; 
            let data = {};
            if (c.cancelTokenSource) {
              c.cancelTokenSource.cancel('Previous request canceled.');
            }

            c.cancelTokenSource = axios.CancelToken.source();

            announcementService.get({cancelToken: c.cancelTokenSource.token }).then(function(response) {
            
                for (let d of response.data) {
                  // Process images for each announcement
                  d.slides = d.images
                    ? Object.values(d.images)
                        .filter(file => file && typeof file === 'string' && file.trim() !== '')
                        .map(file => {
                          const extension = file.split('.').pop()?.toLowerCase() || '';
                          const type = extension === 'mp4' ? 'video' : 'image';
                          return {
                            type,
                            src: `${root}/images/announcement/${d.id}/${file}`
                          };
                        })
                    : [];

                  data[`${d.id}`] = d;
                } 
                
                c.model.announcements = data;
                
                console.log('All announcements with slides:', c.model.announcements);
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        add(){
          const c = this; 
          
          c.model.edit = true;

        },
        edit(id){
          const c = this;

          // console.log(c.model.announcements[0].timer)

          let data = c.model.announcements[`${id}`];

          if (id == c.model.announcement.id) {
            c.model.edit = false;
          } else {
            c.model.edit = true;
          }

          c.model.announcement = {
              id: data.id,
              name: data.name,
              description: data.description,
              active: data.active,
              from: data.startDate,
              to: data.endDate,
              titleSize: data.titleSize,
              descSize: data.descSize,
              verticalPos: data.verticalPos,
              horizontalPos: data.horizontalPos,
              images: data.images
          }

          console.log(c.model)
        },
        save() {
          const c = this;

          const data = c.model.announcement; 

          if (!data.name) {
            utils.alert.error('name is required');
            return;
          }

          if (!data.description) {
            utils.alert.error('description is required');
            return;
          }

          
          if (!data.from) {
            utils.alert.error('start is required');
            return;
          }

        
          if (!data.to) {
            utils.alert.error('end is required');
            return;
          }

          announcementService.save(c.model.announcement)
          .then(function(response){
            utils.alert.success(response.data.message);
            c.get();
            if(response.data.data.active){
              c.sendMessage('announcement')
            }
         
            setTimeout(function(){
              c.reset();
            },500);
        
          })
          .catch(function(error){
            utils.alert.error(error);
          })
     
        },
        sendMessage(state) {
        
          const c = this;

          const messageData = {
          message: state,
          data: c.model.announcement
          };
      
          c.ws.send(JSON.stringify(messageData));
      
      },
        reset() {
          const c = this;
          c.model.edit = false;
          c.model.expandedRow = '',  
          c.model.announcement = {
            id: null,
            name: null,
            description: null,
            active: false,
            from: null,
            to: null,
            images: {},
            titleSize: 2.5,
            descSize: 1.2,
            verticalPos: 'bottom',
            horizontalPos: 'left',
          }
        },
        upload() {
            const c = this;
      
            let data = new FormData();
            data.append('file', this.$refs.file.files[0]);
            data.append('type', 'announcement');
            data.append('id', c.model.announcement.id);
      
            uploadService.uploadFile(data)
              .then(function (response) {
                utils.alert.success('File uploaded!');
              })
              .catch(function (error) {
                utils.alert.error('File failed to uploaded.');
              });
          },
          handleMediaUpload(data){
            const c = this;
            if (!c.model.announcement.images) {
              c.model.announcement.images = {};
            }
            const currentKeys = Object.keys(c.model.announcement.images);
    
            // Determine the next key (numeric)
            const nextKey = currentKeys.length > 0 ? Math.max(...currentKeys.map(Number)) + 1 : 0;

            // Add the new image
            for(i=0;i<data.files.length;i++){
              c.model.announcement.images[nextKey + i] = data.files[i].filename;
            }
          },
          getAnnouncementUrl(){
            const c = this;

            let id = c.model.announcement.id;
            const url = `${root}/images/announcement/${id}/`;
            return url;
            
          },
          removeCurrentFile(data){
            const c = this;

            const id = c.model.announcement.id
            uploadService.deleteFile('announcement', id, data.image)
            .then(function (response) {

              console.log(response.data.id)
              Vue.delete(c.model.announcement.images, data.index)
              utils.alert.success('File Removed!');
            })
            .catch(function (error) {
              utils.alert.error(error);
            });
          },
          resetToDefaults() {
            const c = this;
            c.titleSize = 2.5;
            c.descSize = 1.2;
            c.verticalPos = 'bottom';
            c.horizontalPos = 'left';
            c.titleText = 'Important Announcement';
            c.descText = 'This is a sample announcement description. It provides key details about the event or update, ensuring users can read it clearly over the sliding images.';
          },
    }
  });